import { isGoGameEnv } from 'App/constants';

import { useIsAllowed } from '@gogame/permissions';

const PERMISSION_ARCHIVING = 29;
const PERMISSION_CREATE_CONCEPT = 16; // Manage Gallery Concept
const PERMISSION_CREATE_CREATIVES = 17;
const PERMISSION_MANAGE_CONCEPT_FAMILY = 30;
const PERMISSION_SHARE = 33;
const PERMISSION_UPLOAD_PLAYABLE_AD = 21;
const PERMISSION_CHANGE_CONCEPT_STATUS = 46;

export const useGalleryPermissions = () => {
  const isAllow = useIsAllowed();

  return {
    isAllowBusinessPartner: isGoGameEnv,
    isAllowSimilarConcepts: isGoGameEnv,
    isAllowRequestedBy: isGoGameEnv,
    isAllowJiraTask: isGoGameEnv,
    isAllowConceptFamilies: isGoGameEnv,
    isAllowDesigner: isGoGameEnv,
    isAllowOutsourceStudio: isGoGameEnv,
    isAllowUseInAffiliates: isGoGameEnv,
    isAllowExclusiveForAffiliates: isGoGameEnv,
    isAllowSharedWith: isGoGameEnv,
    isAllowPerformance: isGoGameEnv,
    isAllowPromoCodes: isGoGameEnv,
    isAllowStatuses: isGoGameEnv,
    isAllowCommentMentions: isGoGameEnv,
    isAllowBatchDelete: isGoGameEnv,
    isAllowViewChannel: isGoGameEnv,
    isAllowAddTags: isGoGameEnv,
    isAllowAttachments: isGoGameEnv && isAllow(PERMISSION_CREATE_CONCEPT),
    isAllowManageOutsourceStudio:
      isGoGameEnv && isAllow(PERMISSION_CREATE_CONCEPT),
    isAllowArchiving: isGoGameEnv && isAllow(PERMISSION_ARCHIVING),
    isAllowCreateConcept: isAllow(PERMISSION_CREATE_CONCEPT),
    isAllowManageConceptFamilies:
      isGoGameEnv && isAllow(PERMISSION_MANAGE_CONCEPT_FAMILY),
    isAllowShare: isGoGameEnv && isAllow(PERMISSION_SHARE),
    isAllowUploadPlayable: isAllow(PERMISSION_UPLOAD_PLAYABLE_AD),
    isAllowChangeConceptStatus: isAllow(PERMISSION_CHANGE_CONCEPT_STATUS),
    isAllowCreateCreatives: ({ actions = [] } = {}) => {
      return (
        isAllow(PERMISSION_CREATE_CREATIVES) &&
        actions.includes('Add creatives')
      );
    },
    isAllowViewConcept: ({ actions = [] } = {}) => {
      return actions.includes('View concept');
    },
    isAllowTested: isGoGameEnv,
    isAllowProductionType: isGoGameEnv,
  };
};
